<section class="container">
  @if (selectedTenant && selectedTenant.Value != -1) {
    <div>
      <div class="header-wrapper">
        <h1>Imports</h1>
      </div>
      <ul id="importList">
        <li>
          <h3>Causation Tree</h3>
          <a mat-raised-button class="mat-accent tableBtn" [routerLink]="['new','causationtree']" routerLinkActive="true" data-qa-id="imports-link-causation-tree">
            <mat-icon>add</mat-icon> New Causation Tree Import&nbsp;&nbsp;&nbsp;
          </a>
        </li>
        <li>
          <h3>Hierarchy</h3>
          <a mat-raised-button class="mat-accent tableBtn" [routerLink]="['new','hierarchy']" routerLinkActive="true" data-qa-id="imports-link-hierarchy">
            <mat-icon>add</mat-icon> New Hierarchy Import&nbsp;&nbsp;&nbsp;
          </a>
        </li>
        <li>
          <h3>Historical Data</h3>
          <a mat-raised-button class="mat-accent tableBtn" [routerLink]="['new','historicaldata']" routerLinkActive="true" data-qa-id="imports-link-historical-data">
            <mat-icon>add</mat-icon> New Historical Data Import&nbsp;&nbsp;&nbsp;
          </a>
        </li>
        <li>
          <h3>Historical File Attachments</h3>
          <a mat-raised-button class="mat-accent tableBtn" [routerLink]="['../maintenance']" [queryParams]="{filter: 'Import record file attachments'}" routerLinkActive="true" data-qa-id="imports-link-historical-file-attachments">
            <mat-icon>add</mat-icon> Go to Maintenance Task&nbsp;&nbsp;&nbsp;
          </a>
        </li>
        <li>
          <h3>Users</h3>
          <a mat-raised-button class="mat-accent tableBtn" [routerLink]="['new','users']" routerLinkActive="true" data-qa-id="imports-link-users">
            <mat-icon>add</mat-icon> New Users Import&nbsp;&nbsp;&nbsp;
          </a>
        </li>
      </ul>
    </div>
  }
</section>
